import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBranding = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 21,
	viewBox: "0 0 22 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.01355 10.0001C1.2916 4.77943 5.79052 0.735502 11.0111 1.01355C16.1948 1.28963 20.2672 5.32553 20.0487 9.90966C19.8945 12.8057 17.3911 15.055 14.4951 14.9007C13.5602 14.8509 12.2357 14.4881 11.4487 15.1955C10.8414 15.7413 10.732 16.7682 11.2918 17.3888C12.1101 18.4175 11.3791 20.0711 10.0001 19.9977C4.77943 19.7196 0.735502 15.2207 1.01355 10.0001Z",
			stroke: "#111111",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.00709 9.50003C5.00709 8.94774 5.4548 8.50003 6.00709 8.50003C6.55937 8.50003 7.00709 8.94774 7.00709 9.50003C7.00709 10.0523 6.55937 10.5 6.00709 10.5C5.4548 10.5 5.00709 10.0523 5.00709 9.50003Z",
			stroke: "#111111",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.77737 5.76272C9.77737 5.21044 10.2251 4.76272 10.7774 4.76272C11.3297 4.76272 11.7774 5.21044 11.7774 5.76272C11.7774 6.31501 11.3297 6.76272 10.7774 6.76272C10.2251 6.76272 9.77737 6.31501 9.77737 5.76272Z",
			stroke: "#111111",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.252 9.50003C14.252 8.94774 14.6997 8.50003 15.252 8.50003C15.8043 8.50003 16.252 8.94774 16.252 9.50003C16.252 10.0523 15.8043 10.5 15.252 10.5C14.6997 10.5 14.252 10.0523 14.252 9.50003Z",
			stroke: "#111111",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgBranding);
export default ForwardRef;
